import * as React from 'react';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import AlertItem from './AlertItem';
import {AlertProps} from '../../types/components';

const AlertComponent: React.FC<AlertProps> = (props) => {

    return (
        <div className="alerts">
            <TransitionGroup component={null}>
                {props.alertList.map(item =>
                    <CSSTransition
                        key={item.key}
                        timeout={1000}
                        classNames="fade">
                        <AlertItem removeAlert={() => props.removeAlert(item.key)}
                                   alertText={item.description} alertTitle={item.title} alertType={item.type}/>
                    </CSSTransition>
                )}
            </TransitionGroup>
        </div>
    );
};

export default AlertComponent;
